// Central site configuration.
// Service CTAs point at dedicated pages; prefix an entry with "#" logic by
// using a plain id instead of a path to temporarily point back at a homepage
// section — no homepage redesign needed either way.
// Inquiry delivery: posts to the backend intake. Submission is confirmed by a
// MongoDB write; owner email notification activates once OWNER_EMAIL is set
// on the backend (pending the owner's address).
export const INQUIRY_ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/inquiries`;

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "included", label: "What's included" },
  { id: "process", label: "How it works" },
];

export const SERVICE_LINKS = {
  package: "/business-in-a-box",
  websites: "/website-creation",
  checklist: "/checklist",
};

export const NEED_OPTIONS = [
  "Business in a Box",
  "Website Creation",
  "Launch Checklist",
  "I'm not sure yet",
];

export const MARQUEE_ITEMS = [
  "Wholesale peptide supply",
  "White-label vials",
  "Brand identity",
  "Custom storefront",
  "3PL fulfillment",
  "Product pages",
  "Checkout setup",
  "Launch preparation",
];
